// extracted by mini-css-extract-plugin
export default {"card":"SpecialPriceCard_card__nc4wp"};